/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { Label, Input } from 'reactstrap'

class ImageUploaderClass extends Component {
  handleChange = e => {
    const file = e.target.files[0]
    this.props.onFileUpload(file)
  };

  render() {
    const { image, outputUrl } = this.props

    return (
      <div>
        <Label htmlFor="image" className="mt-3 form-label">
          Display Image
        </Label>

        <div className="dropzone border rounded p-3 text-center">
          {image ? (
            <img
              className="mx-auto d-block"
              height={225}
              src={image}
              alt="Preview"
            />
          ) : (
            <div className="dz-message needsclick">
              <div className="mb-2">
                <i className="display-4 text-muted bx bxs-cloud-upload" />
              </div>
              <h4>Upload your image</h4>
            </div>
          )}
        </div>
        <Input
          className="form-control mt-2"
          type="file"
          id="image"
          accept="image/*"
          onChange={this.handleChange}
        />

        {outputUrl && (
          <div className="mt-4 text-center">
            <a href={outputUrl} download="converted.png">
              <button type="button" className="btn btn-primary">
                Download PNG (8-bit Indexed)
              </button>
            </a>
            <img
              src={outputUrl}
              alt="Converted"
              className="mt-3 border rounded d-block mx-auto"
            />
          </div>
        )}
      </div>
    )
  }
}

export default ImageUploaderClass
